// extracted by mini-css-extract-plugin
module.exports = {"bannerImage":"styles_bannerImage__1FYNZ","productCard":"styles_productCard__mCkH4","No":"styles_No__1j2Sd","cover":"styles_cover__1yNsz"};